import { memo } from 'react';
import { Participant } from 'livekit-client';
import { useTheme } from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';
import { Viewer } from 'features/ParticipantItem/presenters/Speaker';
import { ActiveSpeaker, ActiveSpeakerWindow, CloseButton } from './view';

export interface FloatActiveSpeakerWindowProps {
    participant: Participant;
    className?: string;

    onClick(e: React.MouseEvent<HTMLElement>): void;
}

export const FloatActiveSpeakerWindow: React.FC<FloatActiveSpeakerWindowProps> = memo(
    ({ participant, className, onClick }) => {
        const theme = useTheme();

        return (
            <ActiveSpeakerWindow className={className}>
                <ActiveSpeaker
                    key={participant.identity}
                    participant={participant}
                    PresenterComponent={Viewer}
                    moderationMenuVariant="tile-small"
                />
                <CloseButton type="button" onClick={onClick} size="small">
                    <Icon icon="icClose16" size={16} color={theme.root.colors.basicColors['90%']} />
                </CloseButton>
            </ActiveSpeakerWindow>
        );
    },
);

FloatActiveSpeakerWindow.displayName = 'FloatActiveSpeakerWindow';
